<template>
<div class="scrolly-content-svg">
  <div class="svg-wrapper" :index="index" >
     <st-get-svg v-if="platform" :class="`st-${platform}-svg`" :rootFolder="rootFolder" :platform="platform" @onGetSvg="onGetSvg();" ref="scrollysvgcontainer"></st-get-svg>
  </div>
</div>
</template>

<script>
import StGetSvg from '../SvgFolder/StGetSvg.vue'

export default {
  props: ['rootFolder', 'index'],
  components: {StGetSvg},
  computed: {
    platform () {
      const initWidth = this.$window.innerWidth
      if (!initWidth) return null
      if (initWidth >= 1400) return 'big'
      if (initWidth >= 960) return 'desktop'
      if (initWidth >= 550) return 'tablet'
      return 'mobile'
    },
    // customStyle() {
    //   return {
    //     '--kuala-lumpur-2019-gap': this.data2[0].dash_gap_2019,
    //     '--test-color': 'blue'
    //   }
    // }
  },
  data () {
    return {
      initWidth: null,
      screenGroups: [],
      attrData: [],
      klData: [],
      hkData: [],
      londonData: [],
      sydneyData: [],
    }
    
  },
  mounted () {
    this.initWidth = this.$window.innerWidth
  },
  methods: {
    onGetSvg (svgElem) {
      // TODO
      // this.screenGroups.push(svgElem.querySelectorAll(`g[class*=screen-]`))
    },
    // animateCircles() {
    //   var activeCircles2019 = this.$el.getElementById("circles-active-2019")
    //   console.log(activeCircles2019)
    // },
    
    // dashArray() {
    //   const allGroups = this.$el.getElementsByTagName("g");
    //   console.log(allGroups); 
    // }
  }
}
</script>

<style lang="scss" >
:root {
  //PASTE VALUES HERE
--kuala-lumpur-2019-value: 294;
--kuala-lumpur-2020-value: 16;
--kuala-lumpur-2021-value: 43;

--hong-kong-2019-value: 160;
--hong-kong-2020-value: 81;
--hong-kong-2021-value: 65;

--sydney-2019-value: 77;
--sydney-2020-value: 39;
--sydney-2021-value: 38;

--london-2019-value: 49;
--london-2020-value: 19;
--london-2021-value: 25;

--kuala-lumpur-2019-sqrt: 17.1464281994822;
--kuala-lumpur-2020-sqrt: 4;
--kuala-lumpur-2021-sqrt: 6.557438524302;

--hong-kong-2019-sqrt: 12.6491106406735;
--hong-kong-2020-sqrt: 9;
--hong-kong-2021-sqrt: 8.06225774829855;

--sydney-2019-sqrt: 8.77496438739212;
--sydney-2020-sqrt: 6.2449979983984;
--sydney-2021-sqrt: 6.16441400296898;

--london-2019-sqrt: 7;
--london-2020-sqrt: 4.35889894354067;
--london-2021-sqrt: 5;
  //END OF RADIUS

  //LENGTH OF LINE FROM ILLUSTRATOR + variables
  --var-scale: 0.25%;
  --var-gap-scale-desktop: 10px;
  --var-gap-scale-mobile: 10px;

  --kuala-lumpur-length-mobile: 140.052;
  --hong-kong-length-mobile: 310.094;
  --sydney-length-mobile: 236.037;
  --london-length-mobile: 472.043;
  
  --kuala-lumpur-length-desktop: 163.349;
  --hong-kong-length-desktop: 336.786;
  --sydney-length-desktop: 345.659;
  --london-length-desktop: 688.488;
  //END LENGTH OF LINE


  --kuala-lumpur-2019-gap: calc(var(--kuala-lumpur-length-mobile) / var(--kuala-lumpur-2019-value) * var(--var-gap-scale-mobile));
  --kuala-lumpur-2020-gap: calc(var(--kuala-lumpur-length-mobile) / var(--kuala-lumpur-2020-value) * var(--var-gap-scale-mobile));
  --kuala-lumpur-2021-gap: calc(var(--kuala-lumpur-length-mobile) / var(--kuala-lumpur-2021-value) * var(--var-gap-scale-mobile));

  --hong-kong-2019-gap: calc(var(--hong-kong-length-mobile) / var(--hong-kong-2019-value) * var(--var-gap-scale-mobile));
  --hong-kong-2020-gap: calc(var(--hong-kong-length-mobile) / var(--hong-kong-2020-value) * var(--var-gap-scale-mobile));
  --hong-kong-2021-gap: calc(var(--hong-kong-length-mobile) / var(--hong-kong-2021-value) * var(--var-gap-scale-mobile));

  --sydney-2019-gap: calc(var(--sydney-length-mobile) / var(--sydney-2019-value) * var(--var-gap-scale-mobile));
  --sydney-2020-gap: calc(var(--sydney-length-mobile) / var(--sydney-2020-value) * var(--var-gap-scale-mobile));
  --sydney-2021-gap: calc(var(--sydney-length-mobile) / var(--sydney-2021-value) * var(--var-gap-scale-mobile));

  --london-2019-gap: calc(var(--london-length-mobile) / var(--london-2019-value) * var(--var-gap-scale-mobile));
  --london-2020-gap: calc(var(--london-length-mobile) / var(--london-2020-value) * var(--var-gap-scale-mobile));
  --london-2021-gap: calc(var(--london-length-mobile) / var(--london-2021-value) * var(--var-gap-scale-mobile));

  @media (min-width: 550px) {

  --kuala-lumpur-2019-gap: calc(var(--kuala-lumpur-length-desktop) / var(--kuala-lumpur-2019-value) * var(--var-gap-scale-desktop));
  --kuala-lumpur-2020-gap: calc(var(--kuala-lumpur-length-desktop) / var(--kuala-lumpur-2020-value) * var(--var-gap-scale-desktop));
  --kuala-lumpur-2021-gap: calc(var(--kuala-lumpur-length-desktop) / var(--kuala-lumpur-2021-value) * var(--var-gap-scale-desktop));

  --hong-kong-2019-gap: calc(var(--hong-kong-length-desktop) / var(--hong-kong-2019-value) * var(--var-gap-scale-desktop));
  --hong-kong-2020-gap: calc(var(--hong-kong-length-desktop) / var(--hong-kong-2020-value) * var(--var-gap-scale-desktop));
  --hong-kong-2021-gap: calc(var(--hong-kong-length-desktop) / var(--hong-kong-2021-value) * var(--var-gap-scale-desktop));

  --sydney-2019-gap: calc(var(--sydney-length-desktop) / var(--sydney-2019-value) * var(--var-gap-scale-desktop));
  --sydney-2020-gap: calc(var(--sydney-length-desktop) / var(--sydney-2020-value) * var(--var-gap-scale-desktop));
  --sydney-2021-gap: calc(var(--sydney-length-desktop) / var(--sydney-2021-value) * var(--var-gap-scale-desktop));

  --london-2019-gap: calc(var(--london-length-desktop) / var(--london-2019-value) * var(--var-gap-scale-desktop));
  --london-2020-gap: calc(var(--london-length-desktop) / var(--london-2020-value) * var(--var-gap-scale-desktop));
  --london-2021-gap: calc(var(--london-length-desktop) / var(--london-2021-value) * var(--var-gap-scale-desktop));

  }

  --color-2019: #7bd8ff;
 --color-2020: #3ca2db;
  --color-2021: #005b9b;
}


.component-scrolly {
    background-color: #E6EDEE;

    &:first-of-type {
      background-color: white;
    }
}
@mixin set_scrolly_size($slide_length) {
  [class^="screen-"] {
    transition: opacity 0.5s ease-in;
    opacity: 0;
  }

  @for $i from 0 to $slide_length {
    [index="#{$i}"] .screen-#{$i} {
      transition: opacity 0.5s ease-out;
      opacity: 1;
    }
  }
}

.scrolly-content-svg {

  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 100%;
  @include set_scrolly_size(20);

  svg {
    // rect {
    //   fill: $greydark;
    // }

    .main-lines {
      path {
        // stroke: $greydark;
        // opacity: 50%;
        // stroke-width: 10px;
      }
    }

    [class^="circles-bg-"] {
      circle {
      opacity: 1;
      stroke: $greydark ;
      stroke-width: 1px;
      }
    }

    // .additional-lines {
    //   path {
    //     stroke-width: 70x;
    //   }
    // }
    [class^="screen-"] {
    //KUALA LUMPUR
    #kuala-lumpur-2019-body , [class^="kuala-lumpur-2019-body"] {
      stroke-dasharray: 8px var(--kuala-lumpur-2019-gap);
    }

    #kuala-lumpur-2019-tail , [class^="kuala-lumpur-2019-tail"]{
      stroke-dasharray: 1px calc(var(--kuala-lumpur-2019-gap) + 7px);
    }

    #kuala-lumpur-2019-wing , [class^="kuala-lumpur-2019-wing"]{
      stroke-dasharray: 2px calc(var(--kuala-lumpur-2019-gap) + 6px);
    }

    #kuala-lumpur-2020-body , [class^="kuala-lumpur-2020-body"]{
      stroke-dasharray: 8px var(--kuala-lumpur-2020-gap);
    }

    #kuala-lumpur-2020-tail , [class^="kuala-lumpur-2020-tail"]{
      stroke-dasharray: 1px calc(var(--kuala-lumpur-2020-gap) + 7px);
    }

    #kuala-lumpur-2020-wing , [class^="kuala-lumpur-2020-wing"]{
      stroke-dasharray: 2px calc(var(--kuala-lumpur-2020-gap) + 6px);
    }

    #kuala-lumpur-2021-body , [class^="kuala-lumpur-2021-body"] {
      stroke-dasharray: 8px var(--kuala-lumpur-2021-gap);
    }

    #kuala-lumpur-2021-tail , [class^="kuala-lumpur-2021-tail"]{
      stroke-dasharray: 1px calc(var(--kuala-lumpur-2021-gap) + 7px);
    }

    #kuala-lumpur-2021-wing , [class^="kuala-lumpur-2021-wing"] {
      stroke-dasharray: 2px calc(var(--kuala-lumpur-2021-gap) + 6px);
    }
    

    //HONG KONG

    #hong-kong-2019-body , [class^="hong-kong-2019-body"] {
      stroke-dasharray: 8px var(--hong-kong-2019-gap);
      // opacity: 0.5;
    }

    #hong-kong-2019-tail , [class^="hong-kong-2019-tail"]{
      stroke-dasharray: 1px calc(var(--hong-kong-2019-gap) + 7px);
      // opacity: 0.5;
    }

    #hong-kong-2019-wing , [class^="hong-kong-2019-wing"]{
      stroke-dasharray: 2px calc(var(--hong-kong-2019-gap) + 6px);
      // opacity: 0.5;
    }

    #hong-kong-2020-body , [class^="hong-kong-2020-body"]{
      stroke-dasharray: 8px var(--hong-kong-2020-gap);
    }

    #hong-kong-2020-tail , [class^="hong-kong-2020-tail"]{
      stroke-dasharray: 1px calc(var(--hong-kong-2020-gap) + 7px);
    }

    #hong-kong-2020-wing , [class^="hong-kong-2020-wing"] {
      stroke-dasharray: 2px calc(var(--hong-kong-2020-gap) + 6px);
    }

    #hong-kong-2021-body , [class^="hong-kong-2021-body"]{
      stroke-dasharray: 8px var(--hong-kong-2021-gap);
    }

    #hong-kong-2021-tail , [class^="hong-kong-2021-tail"]{
      stroke-dasharray: 1px calc(var(--hong-kong-2021-gap) + 7px);
    }

    #hong-kong-2021-wing , [class^="hong-kong-2021-wing"] {
      stroke-dasharray: 2px calc(var(--hong-kong-2021-gap) + 6px);
    }
    
    //SYDNEY

    #sydney-2019-body , [class^="sydney-2019-body"]{
      stroke-dasharray: 8px var(--sydney-2019-gap);
    }

    #sydney-2019-tail , [class^="sydney-2019-tail"]{
      stroke-dasharray: 1px calc(var(--sydney-2019-gap) + 7px);
    }

    #sydney-2019-wing , [class^="sydney-2019-wing"]{
      stroke-dasharray: 2px calc(var(--sydney-2019-gap) + 6px);
    }

    #sydney-2020-body , [class^="sydney-2020-body"]{
      stroke-dasharray: 8px var(--sydney-2020-gap);
    }

    #sydney-2020-tail , [class^="sydney-2020-tail"]{
      stroke-dasharray: 1px calc(var(--sydney-2020-gap) + 7px);
    }

    #sydney-2020-wing , [class^="sydney-2020-wing"]{
      stroke-dasharray: 2px calc(var(--sydney-2020-gap) + 6px);
    }

    #sydney-2021-body , [class^="sydney-2021-body"]{
      stroke-dasharray: 8px var(--sydney-2021-gap);
    }

    #sydney-2021-tail , [class^="sydney-2021-tail"]{
      stroke-dasharray: 1px calc(var(--sydney-2021-gap) + 7px);
    }

    #sydney-2021-wing , [class^="sydney-2021-wing"]{
      stroke-dasharray: 2px calc(var(--sydney-2021-gap) + 6px);
    }
    
    //LONDON

    #london-2019-body , [class^="london-2019-body"]{
      stroke-dasharray: 8px var(--london-2019-gap);
    }

    #london-2019-tail , [class^="london-2019-tail"]{
      stroke-dasharray: 1px calc(var(--london-2019-gap) + 7px);
    }

    #london-2019-wing , [class^="london-2019-wing"]{
      stroke-dasharray: 2px calc(var(--london-2019-gap) + 6px);
    }

    #london-2020-body , [class^="london-2020-body"] {
      stroke-dasharray: 8px var(--london-2020-gap);
    }

    #london-2020-tail , [class^="london-2020-tail"]{
      stroke-dasharray: 1px calc(var(--london-2020-gap) + 7px);
    }

    #london-2020-wing , [class^="london-2020-wing"]{
      stroke-dasharray: 2px calc(var(--london-2020-gap) + 6px);
    }

    #london-2021-body , [class^="london-2021-body"]{
      stroke-dasharray: 8px var(--london-2021-gap);
    }

    #london-2021-tail , [class^="london-2021-tail"]{
      stroke-dasharray: 1px calc(var(--london-2021-gap) + 7px);
    }

    #london-2021-wing , [class^="london-2021-wing"]{
      stroke-dasharray: 2px calc(var(--london-2021-gap) + 6px);
    }
    

    #moving-dots-2019, #moving-dots-2020, [class^="moving-dots"] {
      path {
      animation: lineMove 10s linear infinite;
        -moz-animation: lineMove 10s linear infinite;
        -webkit-animation: lineMove 10s linear infinite;
        -ms-animation: lineMove 10s linear infinite;
      }
    }

    #body-2021, #body-2020, #body-2019, [class^="body"]{
      path {
        animation: bodyMove 15s linear infinite;
        -moz-animation: bodyMove 15s linear infinite;
        -webkit-animation: bodyMove 15s linear infinite;
        -ms-animation: bodyMove 15s linear infinite;


        // stroke-dasharray: 10pt;
          stroke-width: 2px;

      }
    }
    #wing-2021, #wing-2020, #wing-2019, [class^="wing"]{
      path {
        animation: wingMove 15s linear infinite;
        -moz-animation: wingMove 15s linear infinite;
        -webkit-animation: wingMove 15s linear infinite;
        -ms-animation: wingMove 15s linear infinite;
        stroke-dashoffset: -2.5px;
        // stroke-width: 5px;
        stroke-width: 10px;
        stroke-linecap: butt;

      }
    }
    #tail-2021, #tail-2020, #tail-2019, [class^="tail"]{
      path {
        animation: tailMove 15s linear infinite;
        -moz-animation: tailMove 15s linear infinite;
        -webkit-animation: tailMove 15s linear infinite;
        -ms-animation: tailMove 15s linear infinite;
        stroke-dashoffset: -8px;
        stroke-width: 6px;
         stroke-linecap: butt;
        //         #sydney-2021-wing {
        //     stroke-width: 7px;

        // }
      }
    }

    [class^="tail-2019"], [class^="wing-2019"], [class^="body-2019"] {
      path {
        stroke: var(--color-2019);
      }

    }

        [class^="tail-2020"], [class^="wing-2020"], [class^="body-2020"] {
      path {
        stroke: var(--color-2020);
      }

    }

        [class^="tail-2021"], [class^="wing-2021"], [class^="body-2021"] {
      path {
        stroke: var(--color-2021);
      }

    }


    // #circles-active-2019,#circles-active-2020, #circles-active-2021 {
    //  circle {
    //   animation: circleGrow 10s linear infinite;
    //   transform-origin: inherit;
    //  } 
    // }

    #sydney-active-2019, [class^="sydney-active-2019"]{
      animation: circleSyd19 10s linear infinite;
      fill: var(--color-2019);

          @keyframes circleSyd19 {

          0% {
              r: 0%;
          }
          80% {
              r: calc(var(--sydney-2019-sqrt) * var(--var-scale));
          }

          100% {
              r: calc(var(--sydney-2019-sqrt) * var(--var-scale));
          }
      }
    }

      #sydney-active-2020, [class^="sydney-active-2020"] {
      animation: circleSyd20 10s linear infinite;
      fill: var(--color-2020);

          @keyframes circleSyd20 {

          0% {
              r: 0%;
          }
          80% {
              r: calc(var(--sydney-2020-sqrt) * var(--var-scale));
          }
          100% {
              r: calc(var(--sydney-2020-sqrt) * var(--var-scale));
          }
      }
    }
    #sydney-active-2021, [class^="sydney-active-2021"] {
      animation: circleSyd21 10s linear infinite;
      fill: var(--color-2021);    
          @keyframes circleSyd21 {

          0% {
              r: 0%;
          }
          80% {
              r: calc(var(--sydney-2021-sqrt) * var(--var-scale));
          }
          100% {
              r: calc(var(--sydney-2021-sqrt) * var(--var-scale));
          }
      }
    }

    #london-active-2019, [class^="london-active-2019"] {
    animation: circleLon19 10s linear infinite;
    fill: var(--color-2019);


        @keyframes circleLon19 {

        0% {
            r: 0%;
        }        
        80% {
            r: calc(var(--london-2019-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--london-2019-sqrt) * var(--var-scale));
        }
    }
  }

    #london-active-2020, [class^="london-active-2020"] {
    animation: circleLon20 10s linear infinite;
    fill: var(--color-2020);


        @keyframes circleLon20 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--london-2020-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--london-2020-sqrt) * var(--var-scale));
        }
    }
  }
  #london-active-2021, [class^="london-active-2021"] {
    animation: circleLon21 10s linear infinite;
    fill: var(--color-2021);
        @keyframes circleLon21 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--london-2021-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--london-2021-sqrt) * var(--var-scale));
        }
    }
  }

  #kuala-lumpur-active-2019, [class^="kuala-lumpur-active-2019"] {
    animation: circleKL19 10s linear infinite;
    fill: var(--color-2019);


        @keyframes circleKL19 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--kuala-lumpur-2019-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--kuala-lumpur-2019-sqrt) * var(--var-scale));
        }
    }
  }

    #kuala-lumpur-active-2020, [class^="kuala-lumpur-active-2020"] {
    animation: circleKL20 10s linear infinite;
    fill: var(--color-2020);
        @keyframes circleKL20 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--kuala-lumpur-2020-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--kuala-lumpur-2020-sqrt) * var(--var-scale));
        }
    }
  }
  #kuala-lumpur-active-2021, [class^="kuala-lumpur-active-2021"] {
    animation: circleKL21 10s linear infinite;
    fill: var(--color-2021);
        @keyframes circleKL21 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--kuala-lumpur-2021-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--kuala-lumpur-2021-sqrt) * var(--var-scale));
        }
    }
  }

  #hong-kong-active-2019, [class^="hong-kong-active-2019"] {
    animation: circleHK19 10s linear infinite;
  fill: var(--color-2019);


        @keyframes circleHK19 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--hong-kong-2019-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--hong-kong-2019-sqrt) * var(--var-scale));
        }
    }
  }

    #hong-kong-active-2020, [class^="hong-kong-active-2020"] {
    animation: circleHK20 10s linear infinite;
    fill: var(--color-2020);
        @keyframes circleHK20 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--hong-kong-2020-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--hong-kong-2020-sqrt) * var(--var-scale));
        }
    }
  }
  #hong-kong-active-2021, [class^="hong-kong-active-2021"] {
    animation: circleHK21 10s linear infinite;
    fill: var(--color-2021);
        @keyframes circleHK21 {

        0% {
            r: 0%;
        }
        80% {
            r: calc(var(--hong-kong-2021-sqrt) * var(--var-scale));
        }
        100% {
            r: calc(var(--hong-kong-2021-sqrt) * var(--var-scale));
        }
    }
  }

  #sydney-bg-2019, [class^="sydney-bg-2019"] {
    r: calc(var(--sydney-2019-sqrt) * var(--var-scale));
  }

    #sydney-bg-2020, [class^="sydney-bg-2020"] {
      r: calc(var(--sydney-2020-sqrt) * var(--var-scale));
    }

    #hong-kong-bg-2019, [class^="hong-kong-bg-2019"] {
    r: calc(var(--hong-kong-2019-sqrt) * var(--var-scale));
  }

    #hong-kong-bg-2020, [class^="hong-kong-bg-2020"] {
      r: calc(var(--hong-kong-2020-sqrt) * var(--var-scale));
    }

  #kuala-lumpur-bg-2019, [class^="kuala-lumpur-bg-2019"] {
    r: calc(var(--kuala-lumpur-2019-sqrt) * var(--var-scale));
  }

    #kuala-lumpur-bg-2020, [class^="kuala-lumpur-bg-2020"]{
      r: calc(var(--kuala-lumpur-2020-sqrt) * var(--var-scale));
    }

    #london-bg-2019, [class^="london-bg-2019"]{
    r: calc(var(--london-2019-sqrt) * var(--var-scale));
  }

    #london-bg-2020, [class^="london-bg-2020"] {
      r: calc(var(--london-2020-sqrt) * var(--var-scale));
    }
  




  }
}
  }




@keyframes lineMove {

  100% {
    stroke-dashoffset: 1000px;
  }
}

@keyframes bodyMove {
  100% {
    stroke-dashoffset: 1000px;
  }
}


@keyframes tailMove {

  100% {
    stroke-dashoffset: 992px;
  }
}

@keyframes wingMove {

  100% {
    stroke-dashoffset: 997.5px;
  }
}


@-moz-keyframes lineMove {
    0% {
        stroke-dashoffset: 0px;
      }
  100% {
    stroke-dashoffset: 1000px;
  }
}

@-moz-keyframes bodyMove {
    0% {
        stroke-dashoffset: 0px;
      }
  100% {
    stroke-dashoffset: 1000px;
  }
}


@-moz-keyframes tailMove {
    0% {
        stroke-dashoffset: -8px;
      }

  100% {
    stroke-dashoffset: 992px;
  }
}

@-moz-keyframes wingMove {
    0% {
        stroke-dashoffset: -2.5px;
      }

  100% {
    stroke-dashoffset: 997.5px;
  }
}

@-webkit-keyframes lineMove {
    100% {
      stroke-dashoffset: 1000px;
    }
  }
  
  @-webkit-keyframes bodyMove {
    0% {
        stroke-dashoffset: 0px;
      }
    100% {
      stroke-dashoffset: 1000px;
    }
  }
  
  
  @-webkit-keyframes tailMove {
    0% {
        stroke-dashoffset: -8px;
      }
  
    100% {
      stroke-dashoffset: 992px;
    }
  }
  
  @-webkit-keyframes wingMove {
    0% {
        stroke-dashoffset: -2.5px;
      }
  
    100% {
      stroke-dashoffset: 997.5px;
    }
  }

  

  

@keyframes circleGrow {
    from {
        r: 1px;
    }
    to {
        r: 30px;
    }
}

svg {
  max-height: 100vh;
  // max-width: 1400px;
}
</style>
